(function(){
  function onReady(fn){ if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  onReady(function(){
    try {
      var CartClass = customElements.get('cart-element');
      if (!CartClass || !CartClass.prototype) return;

      // Harden global Cart helpers to avoid crashes when cart becomes empty
      try {
        if (window.Cart && typeof window.Cart.updateTotals === 'function' && !window.Cart.__cartPatchSafeUpdateTotals) {
          var __origUpdateTotals = window.Cart.updateTotals;
          window.Cart.updateTotals = function(){
            try { return __origUpdateTotals.apply(this, arguments); }
            catch (e) { console.warn('[cart-drawer-patch] Safe updateTotals:', e); return null; }
          };
          window.Cart.__cartPatchSafeUpdateTotals = true;
        }
        if (window.Cart && typeof window.Cart.fetchTotals === 'function' && !window.Cart.__cartPatchSafeFetchTotals) {
          var __origFetchTotals = window.Cart.fetchTotals;
          window.Cart.fetchTotals = function(){
            try { return __origFetchTotals.apply(this, arguments); }
            catch (e) { console.warn('[cart-drawer-patch] Safe fetchTotals:', e); return Promise.resolve(); }
          };
          window.Cart.__cartPatchSafeFetchTotals = true;
        }
      } catch (_) {}

      var originalSwap = CartClass.prototype.swapInNewContent;
      if (typeof originalSwap !== 'function') return;

      CartClass.prototype.swapInNewContent = function(newForm){
        // Snapshot existing summary sub-sections before original swap
        var __prev = {};
        try {
          var prevSummary = this.querySelector('.cart--summary');
          __prev.summary = prevSummary;
          __prev.totals = (prevSummary && prevSummary.querySelector('.cart--totals')) ? prevSummary.querySelector('.cart--totals').cloneNode(true) : null;
          __prev.tax = (prevSummary && prevSummary.querySelector('.cart--tax-info')) ? prevSummary.querySelector('.cart--tax-info').cloneNode(true) : null;
          __prev.nav = (prevSummary && prevSummary.querySelector('.cart--nav')) ? prevSummary.querySelector('.cart--nav').cloneNode(true) : null;
          // Do not snapshot dynamic checkout container to avoid stale wallet state
          __prev.savings = (prevSummary && prevSummary.querySelector('.cart--total-savings')) ? prevSummary.querySelector('.cart--total-savings').cloneNode(true) : null;
          var prevDiscount = this.querySelector('.cart--discount-progress');
          __prev.discount = prevDiscount ? prevDiscount.cloneNode(true) : null;
        } catch(_) {}

        // Call original behavior first
        try { originalSwap.call(this, newForm); } catch (e) { /* continue with patch below */ }

        try {
          // Do NOT replace the entire summary when one already exists.
          // Some partial responses omit sub-sections (e.g., totals/tax) on the first update,
          // causing them to disappear if we wholesale replace .cart--summary.
          // Instead, only append the summary if it doesn't exist yet and update inner parts below.
          var oldSummary = this.querySelector('.cart--summary');
          var newSummary = newForm.querySelector('.cart--summary');
          if (!oldSummary && newSummary) {
            var footerWrap = this.querySelector('.cart--footer');
            if (footerWrap) footerWrap.appendChild(newSummary);
          }

          // Always sync the body so empty-state and line items reflect server response
          var newBody = newForm.querySelector('.cart--body');
          var oldBody = this.querySelector('.cart--body');
          if (newBody && oldBody) {
            oldBody.replaceWith(newBody);
          }
          // Detect if cart is empty in the new response
          var isEmpty = !!(newBody && newBody.querySelector && newBody.querySelector('.cart--empty-state'));

          // If summary exists but some subsections are missing while not empty, restore from snapshot
          var summaryNow = this.querySelector('.cart--summary') || oldSummary || null;
          if (summaryNow && !isEmpty && __prev) {
            try {
              if (!summaryNow.querySelector('.cart--totals') && __prev.totals) {
                summaryNow.appendChild(__prev.totals);
              }
              if (!summaryNow.querySelector('.cart--nav') && __prev.nav) {
                summaryNow.appendChild(__prev.nav);
                // Rebind checkout listeners for restored nav
                try {
                  this.checkout_button = this.querySelector('.cart--checkout-button');
                  if (this.checkout_button && !this.checkout_button.__cartPatchBound) {
                    this.checkout_button.addEventListener('click', () => this.checkout_button.setAttribute('data-loading', true));
                    this.checkout_button.__cartPatchBound = true;
                  }
                } catch(_) {}
              }
              // Do not restore dynamic checkout container from snapshot; rely on server response
              if (!summaryNow.querySelector('.cart--total-savings') && __prev.savings) {
                summaryNow.insertAdjacentElement('afterbegin', __prev.savings);
              }
              var discountNow = this.querySelector('.cart--discount-progress');
              if (!discountNow && __prev.discount) {
                var bodyEl = this.querySelector('.cart--body');
                if (bodyEl) bodyEl.insertAdjacentElement('beforebegin', __prev.discount);
              }
            } catch(_) {}
          }

          // Ensure shipping progress/discount progress are in sync
          var newDiscount = newForm && newForm.querySelector && newForm.querySelector('.cart--discount-progress');
          var oldDiscount = this.querySelector('.cart--discount-progress');
          if (newDiscount) {
            if (oldDiscount) {
              oldDiscount.replaceWith(newDiscount);
            } else {
              var body = this.querySelector('.cart--body');
              if (body) body.insertAdjacentElement('beforebegin', newDiscount);
            }
          } else if (oldDiscount && isEmpty) {
            oldDiscount.remove();
          }

          // Ensure totals are present even if they didn't exist before
          var newTotals = newForm.querySelector('.cart--totals');
          var oldTotals = this.querySelector('.cart--totals');
          if (newTotals) {
            if (oldTotals) {
              oldTotals.replaceWith(newTotals);
            } else {
              var summary = this.querySelector('.cart--summary');
              if (summary) summary.appendChild(newTotals);
            }
          } else if (oldTotals && isEmpty) {
            oldTotals.remove();
          }

          // Keep total price in sync even if we didn't replace the totals block
          try {
            var newTotalPriceEl = newForm.querySelector('.cart--total-price');
            var currTotalPriceEl = this.querySelector('.cart--total-price');
            if (newTotalPriceEl && currTotalPriceEl) {
              currTotalPriceEl.replaceWith(newTotalPriceEl);
            }
          } catch(_) {}

          // Cache last known totals and tax info for resilience
          try {
            var _currTotals = this.querySelector('.cart--totals');
            if (_currTotals) this.__cartPatchLastTotals = _currTotals.cloneNode(true);
            var _currTax = this.querySelector('.cart--tax-info');
            if (_currTax) this.__cartPatchLastTax = _currTax.cloneNode(true);
          } catch(_) {}

          // Ensure nav (Checkout / dynamic checkout buttons) are present
          var newNav = newForm.querySelector('.cart--nav');
          var oldNav = this.querySelector('.cart--nav');
          if (newNav) {
            if (oldNav) {
              oldNav.replaceWith(newNav);
            } else {
              var footer = this.querySelector('.cart--footer');
              if (footer) footer.appendChild(newNav);
            }
            // Refresh cached references and listeners on the new buttons
            this.checkout_button = this.querySelector('.cart--checkout-button');
            this.dynamic_checkout_buttons = this.querySelector('.cart--additional-buttons');
            if (this.checkout_button && !this.checkout_button.__cartPatchBound) {
              this.checkout_button.addEventListener('click', () => this.checkout_button.setAttribute('data-loading', true));
              this.checkout_button.__cartPatchBound = true;
            }
          } else if (oldNav && isEmpty) {
            oldNav.remove();
          }

          // Ensure dynamic checkout buttons container exists and is initialized
          var newAdditional = newForm.querySelector('.cart--additional-buttons');
          var oldAdditional = this.querySelector('.cart--additional-buttons');
          if (newAdditional) {
            if (oldAdditional) {
              oldAdditional.replaceWith(newAdditional);
            } else {
              var footerEl = this.querySelector('.cart--footer');
              var summaryEl = this.querySelector('.cart--summary');
              if (footerEl) footerEl.appendChild(newAdditional);
              else if (summaryEl) summaryEl.appendChild(newAdditional);
            }
            // Update cached reference and (re)enable
            this.dynamic_checkout_buttons = this.querySelector('.cart--additional-buttons');
            if (this.dynamic_checkout_buttons) this.dynamic_checkout_buttons.removeAttribute('data-disabled');

            // Reinitialize Shopify payment buttons (Shop Pay / Google Pay)
            try {
              if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
                Shopify.PaymentButton.init();
              }
            } catch (_) {}
          } else if (oldAdditional && isEmpty) {
            oldAdditional.remove();
          }

          // Update Total Savings block (if returned in new form)
          var newSavings = newForm.querySelector('.cart--total-savings');
          var oldSavings = this.querySelector('.cart--total-savings');
          if (newSavings) {
            if (oldSavings) oldSavings.replaceWith(newSavings);
            else {
              var summaryWrap = this.querySelector('.cart--summary');
              if (summaryWrap) summaryWrap.insertAdjacentElement('afterbegin', newSavings);
            }
          } else if (oldSavings && isEmpty) {
            oldSavings.remove();
          }

          // Update tax info (if changed)
          var newTaxInfo = newForm.querySelector('.cart--tax-info');
          var oldTaxInfo = this.querySelector('.cart--tax-info');
          if (newTaxInfo) {
            if (oldTaxInfo) oldTaxInfo.replaceWith(newTaxInfo);
            else {
              var totalsEl = this.querySelector('.cart--totals');
              if (totalsEl) totalsEl.appendChild(newTaxInfo);
            }
          } else if (oldTaxInfo && isEmpty) {
            oldTaxInfo.remove();
          }

          // Re-evaluate placement of dynamic checkout buttons per theme rules
          try {
            if (typeof this.renderDynamicCheckoutButtons === 'function') {
              this.renderDynamicCheckoutButtons();
            }
          } catch(_) {}

          // If shipping bar was missing originally, insert it
          var newShipping = newForm.querySelector('.cart--shipping');
          var oldShipping = this.querySelector('.cart--shipping');
          if (newShipping && !oldShipping) {
            var header = this.querySelector('.cart--header');
            if (header) header.insertAdjacentElement('afterend', newShipping);
          }

          // Deferred guard: if other scripts mutate the summary after this method,
          // ensure totals and tax info remain present when the cart is not empty.
          var self = this;
          (function deferredGuards(attempt){
            setTimeout(function(){
              try {
                var bodyLate = self.querySelector('.cart--body');
                var summaryLate = self.querySelector('.cart--summary');
                var emptyLate = !!(bodyLate && bodyLate.querySelector && bodyLate.querySelector('.cart--empty-state'));
                if (emptyLate || !summaryLate) return;

                var totalsLate = summaryLate.querySelector('.cart--totals');
                if (!totalsLate) {
                  var fromNewTotals = newForm && newForm.querySelector && newForm.querySelector('.cart--totals');
                  if (fromNewTotals) summaryLate.appendChild(fromNewTotals);
                  else if (self.__cartPatchLastTotals) summaryLate.appendChild(self.__cartPatchLastTotals.cloneNode(true));
                  else if (__prev && __prev.totals) summaryLate.appendChild(__prev.totals);
                }

                var taxLate = summaryLate.querySelector('.cart--tax-info');
                if (!taxLate) {
                  var fromNewTax = newForm && newForm.querySelector && newForm.querySelector('.cart--tax-info');
                  if (fromNewTax) {
                    var totalsContainer = summaryLate.querySelector('.cart--totals');
                    if (totalsContainer) totalsContainer.appendChild(fromNewTax);
                    else summaryLate.appendChild(fromNewTax);
                  } else if (self.__cartPatchLastTax) {
                    var totalsContainer2 = summaryLate.querySelector('.cart--totals');
                    var cloneTax = self.__cartPatchLastTax.cloneNode(true);
                    if (totalsContainer2) totalsContainer2.appendChild(cloneTax);
                    else summaryLate.appendChild(cloneTax);
                  } else if (__prev && __prev.tax) {
                    var totalsContainer3 = summaryLate.querySelector('.cart--totals');
                    if (totalsContainer3) totalsContainer3.appendChild(__prev.tax);
                    else summaryLate.appendChild(__prev.tax);
                  }
                }
              } catch(_) {}
              if (attempt < 2) deferredGuards(attempt + 1);
            }, attempt === 0 ? 0 : attempt === 1 ? 50 : 250);
          })(0);

          // Reload transitions for the cart view
          try {
            if (this.dataset && this.dataset.view && window.Transitions && typeof window.Transitions.reload === 'function') {
              window.Transitions.reload('cart-' + this.dataset.view);
            }
          } catch(_) {}
        } catch (err) {
          console.warn('[cart-drawer-patch] swapInNewContent patch error:', err);
        }
      };

      // Resilient Remove handler: delegate to support dynamically swapped content
      document.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest && ev.target.closest('.quantity-selector--remove');
        if (!btn) return;
        ev.preventDefault();
        // Prefer calling the quantity-selector instance callback
        var qty = btn.closest('quantity-selector');
        if (qty && typeof qty.callback === 'function') {
          try { qty.callback(0); return; } catch(_) {}
        }
        // Fallback: locate cart + line number directly
        var item = btn.closest('.cart--item');
        var cartEl = btn.closest('cart-element');
        if (item && cartEl && typeof cartEl.tryToUpdateQuantity === 'function') {
          var ln = parseInt(item.getAttribute('data-line-num'), 10) || 1;
          try { cartEl.tryToUpdateQuantity(ln, 0); } catch(_) {}
        }
      }, true);
    } catch (e) {
      console.warn('[cart-drawer-patch] initialization error:', e);
    }
  });
})();
